import React from 'react';
import classNames from 'classnames/bind';

import InfoPopup from 'pages-components/InfoPopup';
import Ctx from 'pages-components/Ctx';
import ModalsGroup from 'pages/ProductCard/Tariff/components/ModalsGroup';
import FeeNote from 'pages/ProductCard/Tariff/components/FeeNote';
import AnchorLink from 'pages/ProductCard/Tariff/components/AnchorLink';
import Banners from 'pages/ProductCard/Tariff/components/Banners';
import PageDescriptions from 'pages/ProductCard/Tariff/components/PageDescriptions';
import Authorization from 'widgets/Authorization/Authorization';

import { ITariffCardReactModel, LayoutType } from '../../types';
import { useYoungTariffLayout } from '../useYoungTariffLayout';
import { useESimModalState } from '../useESimModalState';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const HubManager: React.FC<ITariffCardReactModel> = (props) => {
  const anchor = React.useRef<HTMLDivElement>(null);
  const [eSimModalOpen, toogleESimModal] = useESimModalState();
  const isLayoutYoung = useYoungTariffLayout(props.data.layoutType);

  const getAnchorNode = React.useCallback<() => HTMLDivElement | null>(() => anchor.current, []);

  const { fullDescriptionLink, descriptions, banners, esim, feeNote, layoutType } =
    props.data || {};

  return (
    <>
      <ModalsGroup />

      {feeNote && <FeeNote text={feeNote.text} tooltip={feeNote.toolTip} />}

      {eSimModalOpen && <InfoPopup fetchUrl={esim.popupUrl} onClose={toogleESimModal} />}

      {layoutType !== LayoutType.Yandex && (
        <AnchorLink anchor={getAnchorNode}>
          <span className={cx(isLayoutYoung && 'youngFont')}>{Ctx.tariff.descriptionsAnchor}</span>
        </AnchorLink>
      )}

      {/* @ts-expect-error TS and PropTypes conflict */}
      {banners?.length > 0 && <Banners banners={banners} />}

      <div aria-hidden ref={anchor} />

      {/* @ts-expect-error TS and PropTypes conflict */}
      <PageDescriptions
        className={cx(isLayoutYoung && 'youngFont')}
        descriptions={descriptions}
        fullDescriptionLink={fullDescriptionLink}
      />

      <Authorization />
    </>
  );
};
